import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DarkModeService } from '../dark-mode.service';
import { MyMonitoringService } from '../../services/logging.service';
@Component({
  selector: 'app-footer',
  standalone:true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports:[CommonModule,RouterModule,FormsModule],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None

})
export class FooterComponent implements OnInit 
{
  isDarkMode: boolean = false;
  currenYear: number = new Date().getFullYear();

  constructor(
    private darkModeService: DarkModeService,
    private monotoringService: MyMonitoringService) {}

  ngOnInit() {
    this.darkModeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });
  }
  
}
